import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { i18nIntl } from '../lib/ep.js';
import { stage_categories } from '../data/bootstrap_stages.js';

import BuilderCanvas from '../components/builder/BuilderCanvas';
import BuilderMain from '../components/builder/BuilderMain.js';
import BuilderSidebar from '../components/builder/BuilderSidebar';
import Checkbox from '../components/builder/Checkbox';
import MediaUploader from '../components/builder/MediaUploader';
import Model from '../components/builder/Model';
import { NavigationTabsBuilder } from '../components/builder/NavigationTabs';
import RichEditor from '../components/builder/RichEditor';

import Layout from '../components/front/Layout';

import GalleryMosaic from './media/GalleryMosaic.js';

import transferPlaceholder from '../hoc/transferPlaceholder';
import BuilderSubSectionTitle from '../components/backend/BuilderSubSectionTitle.js';
import Message from '../components/builder/Message.js';
import ActionLink from '../components/builder/ActionLink.js';

const RichPlaceHolder = injectIntl(transferPlaceholder(RichEditor));

const StageGalleries = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const stages = props.stages.filter((s) => (s.Stage.type == stage_categories.ID_VOTING_CATEGORY.id))

	const section_main_path = props?.section_main_path ?? 'stages';

	const default_description_text = `<h1>${i18n("Galleries")}</h1><p>${i18n("Click on the stage you want to participate in. The stage must be open.")}</p>`;

	const video_url = (props.pm.galleries_video) ? props.pm.galleries_video.url : null;

	return (
		<BuilderMain pm={props?._promoModel || props.promoModel}>
			<BuilderSidebar onSave={props.savePromo}>
				<NavigationTabsBuilder
					active={`/${section_main_path}/galleries`}
					sections={props.sections}
				/>

				<article>
					<BuilderSubSectionTitle
						title="Galleries public page"
						subtitle="Make the voting galleries visible to non-logged-in users (visitors). Visitors will see the entries but will be required to log in to vote."
						icon='knk-like'
					/>

					<Model model={props.pm} change={props.promoChange}>
						<Checkbox
							name="galleries_enabled"
						>Enable galleries public page</Checkbox>
					</Model>

					{(props.pm?.galleries_enabled ?? false) && (
						<Message>
							<p>{i18n("An access link to the public galleries has been enabled from the Welcome Page. If you unpublish the Welcome Page, users accessing the contest will be automatically redirected to the public galleries.")}</p>
						</Message>
					)}

					{(props.pm?.galleries_enabled ?? false) && (
						<Model model={props.pm} change={props.promoChange}>
							<Checkbox
								name="galleries_hide_votes_to_visitors"
							>Hide the number of votes from unregistered users (visitors)</Checkbox>
						</Model>
					)}
				</article>

				{(stages.length > 1) && (
					<article class="gui_not_in_top_huge">
						<BuilderSubSectionTitle
							title={i18n("Gallery Distributor page")}
							subtitle={<><span>{i18n("This page allows the user to select which gallery they want to access.")}</span> <FormattedMessage id="Set up the layout of the page in the {link} tab." values={{ link:<ActionLink _href='#stages/manager/1' autotranslate={false}>{i18n("***Layout")}</ActionLink> }} /></>}
							autotranslate={false}
							icon='knk-like'
						/>

						<Model model={props.pm} change={props.promoChange}>
							<MediaUploader
								auto_url={`/promotions/auto_img/${props.pm.id}`}
								auto_type={'main'}
								imageField="galleries_image"
								videoField="galleries_video"
								image={props.pm.full_galleries_image}
								video={video_url}
							>Upload media</MediaUploader>

							<RichPlaceHolder
								placeholder={default_description_text}
								name="galleries_description"
								has_emojis={true}
							>Introduction message</RichPlaceHolder>
						</Model>
					</article>
				)}
			</BuilderSidebar>

			<BuilderCanvas
				is_adaptable={true}
				fit_to_window="content"
				enable_actions={true}
				bordered={(stages.length > 1) ? null : false}
			>
				{(stages.length > 1) ? (
					<Layout
						promo={props.pm}
						menus={props.promoModel.Custom__Menus}
						is_builder={true}
						page="stage_mosaic"
					>
						<GalleryMosaic
							is_builder={true}
							stages={stages}
							promotion={props.pm}
						/>
					</Layout>
				) : (
					<p>{i18n("This contest only has one stage with type Gallery.")}</p>
				)}
			</BuilderCanvas>
		</BuilderMain>
	);
}

export default injectIntl(StageGalleries);